import { useState } from'react';
import { useLocation } from 'react-router-dom';
import { menuMap } from '@/constant';

const usePermission = () => {
    const location = useLocation();
    let pathname = location.pathname;
    if (pathname.includes('/main/activityProducts')) {
        pathname = '/main/activities';
    }
    const menuId = menuMap[pathname];
    return {
        menuId
    };
};

export default usePermission;